import React from "react";
import "./BookingConfirm.css";
import NavUser from '../components/NavUser';
import { FaCheckCircle, FaHotel, FaCalendarAlt, FaUsers, FaBed, FaExternalLinkAlt } from "react-icons/fa";

function BookingConfirm() {
  return (
    <div style={{ background: '#f0f2f5', minHeight: '100vh', padding: '20px 0' }}>
      <NavUser />
      <div className="booking-confirm-container">
        <div className="success-icon-wrapper">
          <FaCheckCircle />
        </div>
        
        <h2 className="booking-confirm-title">Booking Confirmed!</h2>
        
        <p className="booking-confirm-message">
          Great news! Your stay at <strong>Grand Palace Hotel</strong> is officially booked. 
          A confirmation email with all the details has been sent to your inbox.
        </p>

        <div className="booking-reference">
          <label htmlFor="bookingRef">Booking Reference Number</label>
          <input
            type="text"
            id="bookingRef"
            className="booking-ref-input"
            value="SW-8829-XLC"
            readOnly
          />
        </div>

        <div className="booking-summary">
          <h3 className="booking-summary-title">Booking Summary</h3>
          <div className="booking-summary-details">
            <div>
              <span><FaHotel /> Hotel</span>
              <p>Grand Palace Hotel</p>
            </div>
            <div>
              <span><FaCalendarAlt /> Check-In</span>
              <p>12th Oct 2025</p>
            </div>
            <div>
              <span><FaCalendarAlt /> Check-Out</span>
              <p>14th Oct 2025</p>
            </div>
            <div>
              <span><FaBed /> Room Type</span>
              <p>Deluxe Garden View</p>
            </div>
            <div>
              <span><FaUsers /> Guests</span>
              <p>2 Adults, 1 Child</p>
            </div>
          </div>
        </div>

        <button className="view-booking-btn">
          View All Bookings <FaExternalLinkAlt style={{ marginLeft: '8px', fontSize: '14px' }} />
        </button>
      </div>
    </div>
  );
}

export default BookingConfirm;
